import React from "react";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import { FilterIcon, XIcon, UploadCloudIcon } from "../Icon/Icon";
import Button from "../Button/Button";
import { Monitor } from "react-feather";

const Container = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 15px;
	width: 100%;
`;

const LeftPanel = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	width: 50%;
	color: ${props => props.theme.primary_one};
	position: relative;

	&:after{
		content: "";
		display: block;
		width: 50px;
		height: 2px;
		background: ${props => props.theme.primary_one};
		position: absolute;
		bottom: -4px;
		left: 0;
	}
`;
const RightPanel = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	width: 50%;
`;

const Title = styled.div`
	font-family: Jost;
	font-style: normal;
	font-weight: bold;
	font-size: 1.4rem;
	line-height: 30px;
	align-self: center;
	color: ${props => props.theme.primary_one};
	margin-left: 8px;
`;

function AssetsMapHeader(props) {
	return (
		<Container>
			<LeftPanel>
				<Monitor />
				<Title>{props.title}</Title>
			</LeftPanel>

			<RightPanel>
				{props.showSendDeleteButton && (
					<>
						<Button
							type="button"
							title="Reenviar Notas"
							success
							small
							onClick={() => props.handleSendDeleteButton("send")}
						>
							<UploadCloudIcon />
						</Button>
						<Button
							type="button"
							title="Excluir Notas"
							danger
							small
							onClick={() =>
								props.handleSendDeleteButton("delete")
							}
						>
							<XIcon />
						</Button>
					</>
				)}
			</RightPanel>
		</Container>
	);
}

export default withRouter(AssetsMapHeader);
